/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead';
import withId from '../../decorators/withId';
import { withTranslation } from '../../translations/i18n';
import GroupedMultiSelectInput from './GroupedMultiSelectInput/GroupedMultiSelectInput';

export class SelectListInput extends Component {
  static propTypes = {
    async: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(PropTypes.object),
    ]),
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    id: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    required: PropTypes.bool,
    ariaLabel: PropTypes.string,
    emptyLabel: PropTypes.string,
    placeholder: PropTypes.string,
    allowNew: PropTypes.bool,
    useCache: PropTypes.bool,
    newSelectionPrefix: PropTypes.string,
    labelKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    filterOptions: PropTypes.func,
    onSearch: PropTypes.func,
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    value: null,
    options: [],
    multiple: false,
    disabled: false,
    onChange: () => {},
    onInputChange: () => {},
    onSearch: () => {},
    ariaLabel: null,
    required: false,
    emptyLabel: null,
    placeholder: null,
    filterOptions: null,
    allowNew: false,
    useCache: true,
    isLoading: false,
    newSelectionPrefix: null,
    labelKey: 'label',
    async: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...SelectListInput.getValueFromProps(props),
      inputText: '',
    };
    this.selectListInputRef = React.createRef();
    this.propertiesRef = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { value } = nextProps;
    if (value !== prevState.previousPropValue) {
      return {
        ...SelectListInput.getValueFromProps(nextProps),
      };
    }
    return null;
  }

  componentDidMount() {
    const selectListInput = this.selectListInputRef.current;
    const propertiesRef = this.propertiesRef.current;
    if (selectListInput && propertiesRef) {
      const ariaOwns = propertiesRef.props['aria-owns'];
      if (ariaOwns) selectListInput.setAttribute('id', ariaOwns);
    }
  }

  onInputChange = (inputText) => {
    this.setState({
      inputText,
    });

    this.props.onInputChange(inputText);
  };

  onChange = (value) => {
    const { onChange, multiple, options } = this.props;
    const { inputText } = this.state;
    this.setState({
      value,
      inputText: value.length > 0 ? inputText : '',
    });
    const record = options.find(item => item.text !== undefined && item.text === value[0]);
    const valueAux = multiple ? value : value[0];
    const result = record || valueAux;
    onChange(result);
  };

  static getValueFromProps({ multiple, value }) {
    return {
      value: (value && (multiple ? [...value] : [value])) || [],
      previousPropValue: value,
    };
  }

  filterOptions = (option, { labelKey }) => {
    const { value, inputText } = this.state;

    if (value && value.includes(option)) {
      return false;
    }

    let optionText = option;
    if (typeof option !== 'string') {
      if (typeof labelKey === 'string') {
        optionText = option[labelKey];
      }
      if (typeof labelKey === 'function') {
        optionText = labelKey(option);
      }
    }
    return optionText.toLowerCase().indexOf(inputText.toLowerCase()) >= 0;
  };

  render() {
    const {
      id,
      ariaLabel,
      required,
      disabled,
      options,
      multiple,
      emptyLabel,
      t,
      placeholder,
      allowNew,
      useCache,
      newSelectionPrefix,
      labelKey,
      filterOptions,
      onSearch,
      isLoading,
      async,
    } = this.props;
    const ComponentToRender = async ? AsyncTypeahead : Typeahead;

    const { value, inputText } = this.state;

    const filterBy = filterOptions ? (...args) => filterOptions(...args, { value, inputText }) : this.filterOptions;

    const textOptions = options.map(item => (item && item.text ? item.text : item));

    return (
      <div className="SelectListInput" ref={this.selectListInputRef}>
        <ComponentToRender
          allowNew={allowNew}
          id={id}
          placeholder={placeholder}
          newSelectionPrefix={newSelectionPrefix || t('Search for ')}
          options={textOptions}
          selected={value}
          multiple={multiple}
          onChange={this.onChange}
          clearButton
          isLoading={isLoading}
          onSearch={onSearch}
          highlightOnlyResult={!allowNew}
          disabled={disabled}
          labelKey={labelKey}
          onInputChange={this.onInputChange}
          filterBy={filterBy}
          useCache={useCache}
          emptyLabel={emptyLabel || t('No matches found')}
          inputProps={{
            ref: this.propertiesRef,
            'data-id': id,
            'aria-label': ariaLabel,
            required,
            autoComplete: 'nofill',
            id,
          }}
        />
      </div>
    );
  }
}


const SelectListInputTranslated = withTranslation()(SelectListInput);

const SelectListWithId = withId('SelectListInput')(SelectListInputTranslated);

SelectListWithId.Grouped = GroupedMultiSelectInput;

export default SelectListWithId;

